module.exports = __webpack_public_path__ + "static/media/BTS_FINALS-10.57ab39ec.jpg";